interface LayerEntry {
  id: string;
  onClose: () => void;
}

class LayerManager {
  private stack: LayerEntry[] = [];

  add(id: string, onClose: () => void) {
    this.stack.push({ id, onClose });
  }

  remove(id: string) {
    this.stack = this.stack.filter((p) => p.id !== id);
  }

  handleEscape() {
    const top = this.stack[this.stack.length - 1];
    if (top) top.onClose();
  }

  clear() {
    this.stack = [];
  }

  isTop(id: string) {
    const top = this.stack[this.stack.length - 1];
    return top?.id === id;
  }
}

export default new LayerManager();
